import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api/v1';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  timeout: 30_000,
});

// ─── Request interceptor: attach auth token ───
api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem('heka_token');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ─── Response interceptor: handle 401 ───
// Guard against the common race where N concurrent requests all get 401
// and each one independently triggers a login redirect. We also don't
// want to redirect from the /login or /register pages themselves (the
// form's own error handling is better UX than a hard reload).
let isRedirectingToLogin = false;

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401 && !isRedirectingToLogin) {
      const path = window.location.pathname;
      const onAuthPage = path === '/login' || path === '/register' || path.startsWith('/forgot-password') || path.startsWith('/reset-password') || path.startsWith('/verify-email');
      if (!onAuthPage) {
        isRedirectingToLogin = true;
        localStorage.removeItem('heka_token');
        // Brief delay lets any in-flight requests settle before the redirect.
        setTimeout(() => { window.location.href = '/login'; }, 50);
      } else {
        localStorage.removeItem('heka_token');
      }
    }
    return Promise.reject(error);
  },
);

export default api;
